// extracted by mini-css-extract-plugin
module.exports = {"palo-logo":"desktopLogo-m__palo-logo__2aj3K","beta":"desktopLogo-m__beta__1QVzk"};